<div class="rounded-[20px] border-[0.5px] border-background-white bg-background-white/80 p-6 backdrop-blur">
  <div class="mb-5 flex justify-center">
    <div class="border-1 rounded-full border border-dashed border-states-red p-[1px]">
      <div class="flex aspect-square h-9 w-9 items-center justify-center rounded-full bg-background-red/20">
        <svg-icon key="px-16-delete-pending" class="text-states-red" size="sm"></svg-icon>
      </div>
    </div>
  </div>

  <h4 class="typo-h4-medium mb-1 text-center">
    {{ 'account_help_contact_express_delete_account_alert_title' | translate }}
  </h4>

  <h5 class="typo-h5-book mb-5 text-center text-text-secondary">
    {{ 'account_help_contact_express_delete_account_alert_message' | translate }}
  </h5>

  <div class="flex gap-x-4">
    <button type="button" class="btn-secondary h-10 w-full justify-center" (click)="onCloseDialog()">
      {{ 'account_help_contact_express_delete_account_alert_cancel' | translate }}
    </button>
    <a
      type="button"
      target="_blank"
      [href]="deleteAccountMailtoLink"
      class="btn-warn h-10 w-full justify-center"
      (click)="onRequestDeleteClick()"
    >
      {{ 'account_help_contact_express_delete_account_alert_confirm' | translate }}
    </a>
  </div>
</div>
